import classNames from "classnames";
import styles from "./index.module.scss";
import { Row, Col, Form, Input, Button, Checkbox, Select, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsOpen } from "@/store/modules/user";
import {
  country,
  userType,
  register,
  getEmailCode,
  checkUserName,
  checkEmailCode,
} from "@/apis/user";
import { useEffect, useState } from "react";
import { encrypt } from "@/utils/jsencrypt";
import intl from "react-intl-universal";

let timer = null;
let formObj = {};
const GUIDE_URL =
  process.env.REACT_APP_OPENGA_USER_GUIDE_URL ||
  (process.env.NODE_ENV === "development"
    ? "https://oga.whu.edu.cn/openGAiframe/docs/user-guide"
    : "/openGAiframe/docs/user-guide");
const Register = () => {
  const { Option } = Select;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countryList, setCountryList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  // const [formObj, setFormObj] = useState([{}])
  const [isShowModal, setIsShowModal] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [captchaUuid, setCaptchaUuid] = useState("");
  let [count, setCount] = useState(120);

  const getSelectList = () => {
    // 国家下拉
    country()
      .then((res) => {
        setCountryList(res.data || []);
      })
      .catch((err) => {});
    // 用户类型下拉
    userType()
      .then((res) => {
        setUserTypeList(res.data || []);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getSelectList();
    return () => {
      timer && clearInterval(timer);
    };
  }, []);

  const msg = intl.get("Please complete this required field");
  const onFinish = (values) => {
    const params = { ...values };
    delete params.password2;
    delete params.agreement;
    params.password = encrypt(values.password);
    // setFormObj(params)
    formObj = params;
    // 验证用户名是否可用
    checkUserName({
      username: params.username,
    })
      .then((res) => {
        message.open({
          type: "success",
          content: intl.get("Register.emailDes"),
          duration: 10,
        });
        getCode();
      })
      .catch((err) => {});
  };

  // 获取邮箱验证码
  const getCode = () => {
    timer && clearInterval(timer);
    getEmailCode({
      email: formObj.email,
      type: 1,
    })
      .then((res) => {
        setIsShowModal(true);
        setCaptchaUuid(res.data);
        // 倒计时
        let num = 120;
        timer = setInterval(() => {
          setCount(num - 1);
          if (num === 0) {
            clearInterval(timer);
          }
          num = num - 1;
        }, 1000);
      })
      .catch((err) => {});
  };

  // 验证邮箱
  const sendEmailCode = (values) => {
    clearInterval(timer);
    checkEmailCode({
      captchaName: formObj.email,
      captchaUuid: captchaUuid,
      captchaValue: values.emailCode,
    })
      .then((res) => {
        // 注册
        register({
          ...formObj,
          captchaRecord: res.data,
        })
          .then((result) => {
            message.success(intl.get("Register.Registered successfully"));
            navigate("/");
            dispatch(setIsOpen(true));
            setTimeout(() => {}, 1500);
          })
          .catch((err) => {});
      })
      .catch((err) => {});
  };

  return (
    <div className={classNames("container", styles.contactFormBox)}>
      <h1>{intl.get("Register.Register")}</h1>
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        style={{ width: "70%" }}
        variant="filled"
        className={styles.formBox}
      >
        <Row gutter={40}>
          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Username")}
              name="username"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Password")}
              name="password"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Confirm Password")}
              name="password2"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: msg,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(intl.get("The new password that you entered do not match")),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Country/Region")}
              name="country"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Select allowClear showSearch>
                {countryList.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={intl.get("Email")}
              name="email"
              rules={[
                {
                  required: true,
                  message: msg,
                },
                {
                  type: "email",
                  message: intl.get("Email must be formatted correctly"),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Nickname")}
              name="nickname"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Input maxLength={30} />
            </Form.Item>
          </Col>
          {/* <Col span={12}>
					<Form.Item
						label={intl.get("Register.Last name")}
						name="lastName"
						rules={[
							{
								required: true,
								message: msg
							},
						]}
					>
						<Input />
					</Form.Item>
				</Col> */}
          <Col span={12}>
            <Form.Item
              label={intl.get("Register.Organizations")}
              name="organization"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Input placeholder={intl.get("Register.organizationName")} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={intl.get("Register.User Type")}
              name="userType"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Select allowClear>
                {userTypeList.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={intl.get("Register.Research aspect")}
              name="researchAspect"
              rules={[
                {
                  required: true,
                  message: msg,
                },
              ]}
            >
              <Input placeholder={intl.get("Register.assetsDes")} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error(intl.get("Register.Should accept agreement"))),
                },
              ]}
            >
              <Checkbox>
                <a href="file" target="_blank">
                  {intl.get("Register.Accept OGE Alliance agreement")}
                </a>
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            {intl.get("Register.Register")}
          </Button>
          <Button
            className={styles.helpButton}
            htmlType="button"
            onClick={() => setIsHelpOpen(true)}
          >
            {intl.get("Register.Help")}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title={
          <div className={styles.helpTitle}>
            <span>{intl.get("Register.OpenGA User Guide")}</span>
            <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer">
              {intl.get("Register.Open in new window")}
            </a>
          </div>
        }
        open={isHelpOpen}
        onCancel={() => setIsHelpOpen(false)}
        footer={null}
        centered
        width="min(1360px, 94vw)"
        className={styles.helpModal}
        destroyOnHidden
      >
        <iframe
          src={GUIDE_URL}
          title={intl.get("Register.OpenGA User Guide")}
          className={styles.helpFrame}
          onLoad={(event) => {
            try {
              const doc = event.currentTarget.contentDocument;
              if (!doc?.head) return;
              const style = doc.createElement("style");
              style.textContent = "html,body{min-width:0 !important;}";
              doc.head.appendChild(style);
            } catch {
              // Cross-origin guides control their own responsive layout.
            }
          }}
        />
      </Modal>

      <Modal
        title={intl.get("Register.Email verification code")}
        width={400}
        open={isShowModal}
        maskClosable={false}
        footer={null}
        onCancel={() => {
          setIsShowModal(false);
        }}
      >
        <Form onFinish={sendEmailCode} autoComplete="off" className={styles.modalFormBox}>
          <Form.Item
            name="emailCode"
            rules={[
              {
                required: true,
                message: intl.get("Register.Please enter the six digit code received by email"),
              },
            ]}
          >
            <Input.OTP />
          </Form.Item>
          <Form.Item className={styles.rightBox}>
            <a>
              未收到验证码，
              <Button type="primary" size="small" onClick={getCode} disabled={count > 0}>
                重新发送 {count > 0 && <span className={styles.countBox}>{count}</span>}
              </Button>
            </a>
          </Form.Item>
          <Form.Item style={{ marginTop: "40px" }}>
            <Button type="primary" htmlType="submit">
              {intl.get("Share.Submit")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Register;
